import { createAsyncThunk } from '@reduxjs/toolkit';
import { CoursesService } from 'Services/axios/Courses.Service';
import { toast } from 'react-toastify';
import { handleApiError } from 'Features/Common/ErrorHandler';

export const fetchCourses = createAsyncThunk(
  'Courses/fetchCourses',
  async (filters) => {
    try {
      const response = await CoursesService.getAll(filters);
      return response.data;
    } catch (error) {
      handleApiError(error);
      throw error;
    }
  }
);

export const submitCourses = createAsyncThunk(
  'addCourses/submitCourses',
  async (data) => {
    try {
      const formData = new FormData();
      formData.append('title', data.title);
      formData.append('description', data.description);
      data.description_video && formData.append('description_video', data.description_video);
      data.description_image && formData.append('description_image', data.description_image);
      data.image && formData.append('banner', data.image);

      let response;
      if (data.isUpdate) {
        response = await CoursesService.update(data.id, formData);
        toast.success('Course berhasil diperbarui', {
          position: toast.POSITION.TOP_RIGHT
        });
      } else {
        response = await CoursesService.create(formData);
        toast.success('Course berhasil ditambahkan', {
          position: toast.POSITION.TOP_RIGHT
        });
      }
      data.successCallback && data.successCallback();
      return response.data.data;
    } catch (error) {
      handleApiError(error);
      throw error;
    }
  }
);

export const deleteCourses = createAsyncThunk(
  'deleteCourses/deleteCourses',
  async (id) => {
    try {
      const response = await CoursesService.delete(id);
      toast.success(response.data.message, {
        position: toast.POSITION.TOP_RIGHT
      });
      return id;
    } catch (error) {
      handleApiError(error);
      throw error;
    }
  }
);

export const attachDetachCourses = createAsyncThunk(
  'attachDetachCourses/attachDetachCourses',
  async (data) => {
    try {
      const formData = new FormData();
      data.materials.forEach((material, index) => {
        formData.append(`material[${index}][id]`, material.value);
      });
      await CoursesService.attachDetach(data.id, formData);
      return true;
    } catch (error) {
      handleApiError(error);
      throw error;
    }
  }
);
